import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import SettingsPortalBrandingPanel from "../AdminSettings/SettingsPortalBrandingPanel";
import {
  DesktopDialog,
  HubFormCard,
  HubSheet,
  HubSheetActions,
} from "../AdminPortal/HubPwa";
import { useIsMobile } from "../../../hooks/useMediaQuery";
import aa from "../AdminPortal/adminApp.module.css";
import { Field, Input, PhoneInput, Textarea, useToast } from "../../ui";

export default function AdminClubEditSheet({ open, tenant, onClose, onUpdated }) {
  const toast = useToast();
  const isMobile = useIsMobile(768);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [saving, setSaving] = useState(false);
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!open || !tenant) return;
    setName(tenant.name || "");
    setDescription(tenant.portal_description || "");
    setPhone(tenant.phone || "");
    setAddress(tenant.address || "");
    setBranding(tenant);
  }, [open, tenant]);

  const saveInfo = async () => {
    if (!name.trim() || name.trim().length < 2) {
      toast.error("Название клуба слишком короткое");
      return;
    }
    setSaving(true);
    try {
      const res = await clinicAPI.updateTenantSettings({
        name: name.trim(),
        portal_description: description.trim(),
        phone: phone.trim(),
        address: address.trim(),
      });
      const next = res.tenant;
      setBranding(next);
      onUpdated?.(next);
      toast.success("Сохранено");
      onClose?.();
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  const handleBrandingUpdated = (next) => {
    setBranding(next);
    onUpdated?.(next);
  };

  if (!open) return null;

  const footer = (
    <HubSheetActions
      primary={saving ? "Сохранение…" : "Сохранить"}
      secondaryLabel="Отмена"
      onSecondary={onClose}
      primaryType="button"
      primaryDisabled={saving}
      onPrimary={saveInfo}
    />
  );

  const body = (
    <>
      <HubFormCard title="О клубе">
        <Field label="Название">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Название клуба"
          />
        </Field>
        <Field label="Описание">
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Кратко о клубе, направлениях и атмосфере"
            rows={5}
          />
        </Field>
        <Field label="Телефон">
          <PhoneInput value={phone || ""} onChange={setPhone} />
        </Field>
        <Field label="Адрес">
          <Input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Город, улица, дом"
          />
        </Field>
      </HubFormCard>

      {branding ? (
        <div className={aa.adminClubEditBranding}>
          <SettingsPortalBrandingPanel
            compact={isMobile}
            desktop={!isMobile}
            accentColor={branding.portal_accent_color}
            coverUrl={branding.portal_cover_url}
            logoUrl={branding.logo_url}
            fontFamily={branding.portal_font_family}
            galleryUrls={branding.portal_gallery || []}
            onUpdated={handleBrandingUpdated}
          />
        </div>
      ) : null}
    </>
  );

  if (!isMobile) {
    return (
      <DesktopDialog
        open={open}
        onClose={onClose}
        title="Редактировать клуб"
        subtitle="Как видят клиенты на вкладке «Клуб»"
        wide
        dialogClassName={aa.adminClubEditDialog}
        bodyClassName={aa.adminClubEditBody}
        footer={footer}
      >
        {body}
      </DesktopDialog>
    );
  }

  return (
    <HubSheet
      open={open}
      onClose={onClose}
      title="Редактировать клуб"
      subtitle="Как видят клиенты на вкладке «Клуб»"
      bodyClassName={aa.adminClubEditBodyMobile}
      footer={footer}
    >
      {body}
    </HubSheet>
  );
}
